import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import { ComoSuena, ComoFunciona, QueIncluye, Marquee } from "@/components/Sections1";
import { LoQueNoHace, Cita, Preguntas } from "@/components/Sections2";
import { PrimeraSemana, Contacto, Footer, WhatsAppFloat } from "@/components/Sections3";
import CookieConsent from "@/components/CookieConsent";
import { AvisoLegal, PoliticaCookies, PoliticaPrivacidad } from "@/pages/Legal";

function useParallax() {
  useEffect(() => {
    const fine =
      window.innerWidth >= 768 &&
      !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!fine) return;
    const els = Array.from(document.querySelectorAll("[data-plx]"));
    let ticking = false;
    const update = () => {
      els.forEach((el) => {
        const target = el.querySelector(".plx-in");
        if (!target) return;
        const r = el.getBoundingClientRect();
        const f = parseFloat(el.dataset.plx) || 0.15;
        target.style.transform = `translate3d(0, ${(r.top * f).toFixed(1)}px, 0)`;
      });
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    update();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
}

function Landing() {
  useParallax();
  useEffect(() => {
    document.title = "Kanvia · IA que contesta el teléfono de tu restaurante";
  }, []);
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ComoSuena />
        <ComoFunciona />
        <QueIncluye />
        <Marquee />
        <LoQueNoHace />
        <Cita />
        <Preguntas />
        <Marquee id="marquee-2" />
        <PrimeraSemana />
        <Contacto />
      </main>
      <Footer />
      <WhatsAppFloat />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <div className="bg-noche font-mono text-crema antialiased">
        <div className="grain" aria-hidden="true" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/aviso-legal" element={<AvisoLegal />} />
          <Route path="/politica-de-privacidad" element={<PoliticaPrivacidad />} />
          <Route path="/politica-de-cookies" element={<PoliticaCookies />} />
        </Routes>
        <CookieConsent />
      </div>
    </BrowserRouter>
  );
}
